import { composeWithDevTools } from "redux-devtools-extension";
import { applyMiddleware, createStore } from "redux";
import { createLogger } from "redux-logger";
import { rootReducer } from "./reducers/root-reducer";
import { initialState } from "./initial-state";


const middleware: any = [];

const getMiddleware = () => {
    if (process.env.NODE_ENV === "production") {
        return applyMiddleware(...middleware);
    } else {
        // Enable additional logging in non-production environments.
        return applyMiddleware(...middleware, createLogger());
    }
}

const store = createStore(
    rootReducer,
    initialState,
    composeWithDevTools(getMiddleware())
);

export { store };